import Vue from 'vue';
import VueMq from 'vue-mq';

Vue.use(VueMq, {
  breakpoints: {
    xs: 375,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1280,
    // xxl: 1440,
  },
  defaultBreakpoint: 'xs',
});
